// extracted by mini-css-extract-plugin
module.exports = {"aboutTodoList":"AboutTodoList_aboutTodoList__1trjs","aboutTodoListReposition":"AboutTodoList_aboutTodoListReposition__3uHDh"};